<script>
import { mapGetters } from 'vuex';
import Base from './base.vue';
import { get, includes } from 'lodash';
import { ZOOM_MEETING_EDU_PLUS_MIN_LICENSE, BASE_PLAN_SUB_TYPES, ZOOM_MEETING_EDU_SCH_CMP_MIN_LICENSE } from '@/common/constants';
import { getAssignedLicenseQuantity } from '@/plans/ZOOM_ONE_BUNDLE/utils'
import { getMeetingPlanByCategory } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  name: 'Switch',
  extends: Base,
  computed: {
    ...mapGetters(['boughtPlans', 'migratePlanState','assignInfo']),
    isShowLeastDesc() {
      return true;
    },
    addRegionVisible() {
      return false
    },
    assignedEduLicenseQuantity() {
      const boughtMeetingPlan = getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.EDUCATION);
      return getAssignedLicenseQuantity([boughtMeetingPlan], this.assignInfo);
    },
    maxLicenseAddonLicense(){
      return get(this.maxLicenseAddon, 'cartInfo.selected_number', 0);
    },
    selectedNum(){
      return get(this.selfPlan?.[0], 'cartInfo.selected_number', 0);
    },
    minHost(){
      return ZOOM_MEETING_EDU_SCH_CMP_MIN_LICENSE;
    },
    minHostAndReason(){
      // add-on
      const selected_num  = this.selectedNum || this.minHost;
      if (selected_num <= this.maxLicenseAddonLicense) {
        const maxLicenseAddonTypeNameKey = this.maxLicenseAddon.typeNameKey;
        const maxLicenseAddonTypeName = this.$t(maxLicenseAddonTypeNameKey);
        return {
          reason: this.$t('billing.meeting_license_decrease_tips_need_decrease_addon', { product: maxLicenseAddonTypeName }),
          minHost: Math.max(this.maxLicenseAddonLicense, this.minHost)
        }
      }
      return ''
    },
    minCallingPlan() {
      // add-on
      if (this.minHost <= this.maxLicenseAddonLicense) {
        return this.minHostAndReason?.minHost 
      }
      if(this.assignedEduLicenseQuantity > ZOOM_MEETING_EDU_PLUS_MIN_LICENSE){
        return Math.max(this.assignedEduLicenseQuantity, ZOOM_MEETING_EDU_PLUS_MIN_LICENSE); 
      }
      return ZOOM_MEETING_EDU_PLUS_MIN_LICENSE;
    },
    maxCallingPlan() {
      return 9999;
    },
    planDetailLabel() {
      return this.$t('billing.zone.explore_other_plans_edit');
    },
    maxLicenseAddon() {
      return this.getUserCurrentSubscriptions
        .filter(item => includes(this.limitLicenseWithBaseZoneTypes, item.type))
        .reduce((maxPlan, plan) => {
          if (plan.cartInfo.selected_number > get(maxPlan, 'cartInfo.selected_number', 0)) {
            return plan;
          }
          return maxPlan;
        }, {});
    },
    licenseTip() {
      return this.minHostAndReason.reason;
    }
  },
}
</script>

<style lang="scss">
  .opc-zeduschp-license-tip {
    margin-top: 12px !important;
  }
</style>

